<template>
  <b-modal size="xl" v-model="showModalMap" id="modal-map" centered
           body-class="my-body" hide-footer hide-header @hidden="hide">
    <b-row style=" flex-grow : 1; margin-bottom: 0px" :class="{ hidden: true, 'show-hidden': !isHidden }">
      <b-col id="sidebar_main" style="padding: 10px" class="sidebar2">
        <md-card style="background-color: white; max-height: 75vh; overflow-y: scroll;">
          <md-card-content>
            <b-row style="border-bottom:1px solid #b3b3b3; margin-bottom: 12px; margin-top: 16px">
              <b-col>
                <p style="color: #525252" class="font-lg"><b>Filter</b></p>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Ort:" label-for="select_ort">
                  <b-form-select class="black" id="select_ort" plain v-on:input="changeFilter"
                                 v-model="selections.ort" :options="selects.ort">
                    <template v-slot:first>
                      <b-form-select-option :value="null">-- Alle --
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Ortsteil:" label-for="select_ortsteil">
                  <b-form-select class="black" id="select_ortsteil" plain v-on:input="changeFilter"
                                 v-model="selections.ortsteil" :options="selects.ortsteil">
                    <template v-slot:first>
                      <b-form-select-option :value="null">-- Alle --
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Objekt:" label-for="select_objekt">
                  <b-form-select class="black" id="select_objekt" plain v-on:input="changeFilter"
                                 v-model="selections.objekt" :options="selects.objekt">
                    <template v-slot:first>
                      <b-form-select-option :value="null">-- Alle --
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Maßnahme:" label-for="select_massnahme">
                  <b-form-select class="black" id="select_massnahme" plain v-on:input="changeFilter"
                                 v-model="selections.massnahme" :options="selects.massnahme">
                    <template v-slot:first>
                      <b-form-select-option :value="null">-- Alle --
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </md-card-content>
        </md-card>
      </b-col>
      <b-col style="height: 600px; padding: 0; margin-bottom: 0; overflow: hidden" id="map_container"
             ref="map_container" v-on:toggle-sidebar="toggleSideBar">
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import LanguageControl from 'mapbox-gl-controls/lib/language';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import TaskMapPopup from "@/views/aufgaben_verwaltung/TaskMapPopup.vue";
import ClearIcon from 'vue-material-design-icons/CloseCircle.vue';
import StylesControl from 'mapbox-gl-controls/lib/styles';


import Vue from 'vue';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import booleanPointInPolygon from '@turf/boolean-point-in-polygon'
import {arrayContains} from "@/shared/utils";

require('../../shared/free_draw');

class MyCustomControl {
  onAdd(map) {
    this.map = map;
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
    this.button = document.createElement('button');
    this.button.innerHTML = "☰ Filter";
    this.button.onclick = () => {
      let event = new Event('toggle-sidebar');
      this.button.dispatchEvent(event);
    };
    this.container.appendChild(this.button);
    return this.container;
  }

  onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }
}

const myCustomControl = new MyCustomControl();


export default {
  name: "TaskMap",
  components: {
    ClearIcon,
  },
  data() {
    return {
      showModalMap: false,
      items: [],
      filteredItems: [],
      isHidden: true,
      closeToggle: new class {
        constructor(parent) {
          this.parent = parent;
        }

        onAdd(map) {
          this.map = map;
          this.container = document.createElement('div');
          this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
          this.button = document.createElement('button');
          this.button.innerHTML = "&#x2715; Schließen";
          this.button.onclick = this.parent.closeMap;
          this.container.appendChild(this.button);
          return this.container;
        }

        onRemove() {
          this.container.parentNode.removeChild(this.container);
          this.map = undefined;
        }
      }(this),
      createTourToggle: new class {
        constructor(parent) {
          this.parent = parent;
        }

        onAdd(map) {
          this.map = map;
          this.container = document.createElement('div');
          this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
          this.container.id = 'create_tour'
          this.container.ref = 'create_tour'
          this.container.style.background = 'green';
          this.button = document.createElement('button');
          this.button.innerHTML = "Tour erstellen";
          this.button.onclick = this.parent.createTour;
          this.button.style.color = 'white';
          this.container.appendChild(this.button);
          return this.container;
        }

        onRemove() {
          this.container.parentNode.removeChild(this.container);
          this.map = undefined;
        }
      }(this),
      sidebarToggle: new class {
        constructor(parent) {
          this.parent = parent;
        }

        onAdd(map) {
          this.map = map;
          this.container = document.createElement('div');
          this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
          this.button = document.createElement('button');
          this.button.innerHTML = "☰ Filter";
          this.button.onclick = this.parent.toggleSideBar;
          this.container.appendChild(this.button);
          return this.container;
        }

        onRemove() {
          this.container.parentNode.removeChild(this.container);
          this.map = undefined;
        }
      }(this),
      navopen: false,
      selects: {
        ort: [],
        ortsteil: [],
        objekt: [],
        massnahme: [],
      },
      selections: {
        ort: null,
        ortsteil: null,
        objekt: null,
        massnahme: null,
      },
    }
  },
  methods: {
    toggleSideBar() {
      if (!this.navopen) {
        document.getElementById("sidebar_main").style.width = "250px";
        document.getElementById("sidebar_main").style.visibility = "visible";
      } else {
        document.getElementById("sidebar_main").style.width = "0px";
        document.getElementById("sidebar_main").style.visibility = "hidden";
      }
      this.navopen = !this.navopen;
    },
    hide() {
      if (this.markers !== null) {
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].remove();
        }
        this.markers = null;
      }
      this.items = [];
      if (this.map !== null) {
        this.map.remove();
        this.map = null;
      }
    },
    closeMap() {
      this.showModalMap = false;
      this.map = null;
    },
    createTour() {
      let selected = [];
      let hasAlreadyPlanned = false;
      for (let i = 0; i < this.markers.length; i++) {
          if (this.markers[i].isSelected) {
            let id = this.markers[i].bisId;
            for (let j = 0; j < this.items.length; j++) {
              if (this.items[j].id === id) {
                if ((this.items[j].count_open + this.items[j].count_finished) > 0 || this.items[j].complete === 10) {
                    hasAlreadyPlanned = true;
                } else {
                  selected.push(this.items[j]);
                }
              }
            }
          }
      }
      if (hasAlreadyPlanned) {
        this.$bvToast.toast("Teilweise sind Aufgaben der Selektion bereits beplant oder abgeschlossen. Diese Aufgaben werden bei der Tourerstellung nicht beachtet.", {
          title: 'Aufgaben bereits beplant oder abgeschlossen',
          autoHideDelay: 3000,
          appendToast: false,
          toaster: 'b-toaster-top-center',
          bodyClass: 'toast-pre-wrap'
        })
      }
      if (selected.length === 0) {
        this.$bvToast.toast("Keine der selektierten Aufgaben erfüllt die Anforderungen der Tourenplanung.", {
          title: 'Tourenplanung nicht möglich',
          autoHideDelay: 3000,
          appendToast: false,
          toaster: 'b-toaster-top-center',
          bodyClass: 'toast-pre-wrap'
        })
        return;
      }
      this.$emit('map_plan', selected);
      this.closeMap();
    },
    showMapIfNeeded() {
      let bounds = new (mapboxgl.LngLatBounds);
      for (let i = 0; i < this.items.length; i++) {
        bounds.extend(new mapboxgl.LngLat(this.items[i].lon, this.items[i].lat));
      }
      mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
      this.map = new mapboxgl.Map({
        container: 'map_container',
        style: 'mapbox://styles/mapbox/outdoors-v11',
        bounds: bounds,
        zoom: 18,
        minZoom: 5,
        maxPitch: 0,
        attributionControl: false
      });

      this.draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true
        }
      });
      this.map.addControl(this.sidebarToggle, 'top-left');
      this.map.addControl(this.draw, 'top-left');

      this.map.addControl(new ZoomControl(), 'bottom-right');
      this.map.addControl(this.closeToggle, 'top-right');
      this.map.addControl(this.createTourToggle, 'top-left');
      const languageControl = new LanguageControl({
        language: 'de',
      });
      this.map.addControl(languageControl);

      this.marker = null;
      this.markers = null;
      this.geojson = {};
      this.map.on('load', this.mapLoad);
    },
    changeFilter() {
      this.filteredItems = [];
      for (let i = 0; i < this.items.length; i++) {
        let contains = true;
        if (this.selections.objekt !== null && this.items[i].auftrag_wo !== this.selections.objekt) {
          contains = false;
        }
        if (this.selections.massnahme !== null && this.items[i].massnahme !== this.selections.massnahme) {
          contains = false;
        }
        if (this.selections.ort !== null && this.items[i].ort !== this.selections.ort) {
          contains = false;
        }
        if (this.selections.ortsteil !== null && this.items[i].ortsteil !== this.selections.ortsteil) {
          contains = false;
        }
        if (contains) {
          this.filteredItems.push(this.items[i])
        }
      }
      this.onAreaUpdated()
    },
    onAreaUpdated(e) {
      let polygons = this.draw.getAll();
      let hasInside = false;
      if (polygons.length === 0) {
        this.drawMarkers();
      } else {
        this.removeMarkers();
        for (let i = 0; i < this.filteredItems.length; i++) {
          let isInside = false;
          for (let j = 0; j < polygons.features.length; j++) {
            if (booleanPointInPolygon([this.filteredItems[i].lon, this.filteredItems[i].lat], polygons.features[j])) {
              isInside = true;
              hasInside = true;
              break;
            }
          }
          let el = document.createElement('div');
          el.className = isInside ? 'marker_selected' : 'marker';
          el.id = this.filteredItems[i].id;

          let ComponentClass = Vue.extend(TaskMapPopup);
          let instance = new ComponentClass();
          instance.$slots.header = [ this.filteredItems[i].auftrag_wo ];
          instance.$slots.subject = [ this.filteredItems[i].auftrag_was ];
          instance.$slots.memo = [ this.filteredItems[i].description ];
          instance.$mount();
          let p = new mapboxgl.Popup()
              .setLngLat([this.filteredItems[i].lon, this.filteredItems[i].lat]).setDOMContent(instance.$el);

          let marker = new mapboxgl.Marker({
            element: el,
            anchor: 'center',
          })
              .setLngLat([this.filteredItems[i].lon, this.filteredItems[i].lat])
              .setPopup(p)
              .addTo(this.map);
          marker.bisId = this.filteredItems[i].id;
          marker.isSelected = isInside;
          this.markers.push(marker);
        }
      }
      document.getElementById("create_tour").style.visibility = hasInside ? "visible" : "hidden";

    },
    removeMarkers() {
      if (this.markers === null || this.markers.length === 0) {
        this.markers = [];
        return;
      }
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].remove();
      }
      this.markers = [];
    },
    drawMarkers() {
      this.removeMarkers()
        for (let i = 0; i < this.filteredItems.length; i++) {
          let el = document.createElement('div');
          el.className = 'marker';
          el.id = this.items[i].id;
          //el.addEventListener('click', this.onMarkerClicked);

          let ComponentClass = Vue.extend(TaskMapPopup);
          let instance = new ComponentClass();
          instance.$slots.header = [ this.items[i].auftrag_wo ];
          instance.$slots.subject = [ this.items[i].auftrag_was ];
          instance.$slots.memo = [ this.items[i].description ];
          instance.$mount();
          let p = new mapboxgl.Popup()
              .setLngLat([this.items[i].lon, this.items[i].lat]).setDOMContent(instance.$el);

          let marker = new mapboxgl.Marker({
            element: el,
            anchor: 'center',
          })
              .setLngLat([this.items[i].lon, this.items[i].lat])
              .setPopup(p)
              .addTo(this.map);
          marker.bisId = this.items[i].id;
          this.markers.push(marker);
        }
    },
    mapLoad() {
      setTimeout(() => {
        if (this.markers === null) {
          this.onAreaUpdated();
          this.map.on('draw.create', this.onAreaUpdated);
          this.map.on('draw.delete', this.onAreaUpdated);
          this.map.on('draw.update', this.onAreaUpdated);
        }
        this.map.resize();
        this.isHidden = false;
      });
    },
    showMap(items) {
      console.log(items)
      this.isHidden = true;
      this.marker = null;
      this.markers = null;
      this.items = [];

      this.selects.ort = [];
      this.selects.ortsteil = [];
      this.selects.objekt = [];
      this.selects.massnahme = [];

      this.selections.ort = null;
      this.selections.ortsteil = null;
      this.selections.objekt = null;
      this.selections.massnahme = null;

      for (let i = 0; i < items.length; i++) {
        if (items[i].lat !== 0.0 && items[i].lon !== 0.0) {
          if (items[i].auftrag_wo !== '' && !arrayContains(this.selects.objekt, items[i].auftrag_wo)) {
            this.selects.objekt.push(items[i].auftrag_wo);
          }
          if (items[i].massnahme !== '' && !arrayContains(this.selects.massnahme, items[i].massnahme)) {
            this.selects.massnahme.push(items[i].massnahme);
          }
          if (items[i].ort !== '' && !arrayContains(this.selects.ort, items[i].ort)) {
            this.selects.ort.push(items[i].ort);
          }
          if (items[i].ortsteil !== '' && !arrayContains(this.selects.ortsteil, items[i].ortsteil)) {
            this.selects.ortsteil.push(items[i].ortsteil);
          }
          this.items.push(items[i]);
          this.filteredItems.push(items[i]);
        }
      }
      this.selects.objekt.sort((a,b) => (a.toLowerCase() > b.toLowerCase()) ? 1 : ((b.toLowerCase() > a.toLowerCase()) ? -1 : 0));
      this.selects.massnahme.sort((a,b) => (a.toLowerCase() > b.toLowerCase()) ? 1 : ((b.toLowerCase() > a.toLowerCase()) ? -1 : 0));
      this.selects.ort.sort((a,b) => (a.toLowerCase() > b.toLowerCase()) ? 1 : ((b.toLowerCase() > a.toLowerCase()) ? -1 : 0));
      this.selects.ortsteil.sort((a,b) => (a.toLowerCase() > b.toLowerCase()) ? 1 : ((b.toLowerCase() > a.toLowerCase()) ? -1 : 0));

      if (this.items.length === 0) {
        this.$emit('close-map', {reason: 'no-coords'})
        return;
      }
      this.showModalMap = true;
      this.$nextTick(() => {
        this.showMapIfNeeded();
      });
    },
  }
}
</script>

<style scoped>
.hoverable-icon:hover {
  cursor: pointer;
}
</style>

<style>
.black {
  color: black;
}
.mapboxgl-popup {
  max-width: 600px !important;
  z-index: 2;
}
.mapboxgl-popup-close-button {
  font-size: 20px;
}

.marker {
  background-image: url('../../../public/mangel_marker.png');
  background-size: cover;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.marker_selected {
  background-image: url('../../../public/marker_selected.png');
  background-size: cover;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.my-body {
  padding: 0 !important;
}

.hidden {
  opacity: 0;
  transition: opacity 0.1s ease-in;
}

.mapboxgl-popup-close-button {
  outline: none !important;
}

.show-hidden {
  opacity: 1;
}


.sidebar2 {
  visibility: hidden;
  width: 0;
  position: absolute;
  z-index: 1 !important;
  overflow-x: hidden;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  -moz-transition: 0.5s;
  padding: 0;
  top: 50px;
  -webkit-transition-property: width, visibility;
  transition-property: width, visibility;
  -moz-transition-property: width, visibility;
  -webkit-transition-timing-function: ease;
  transition-timing-function: ease;
  -moz-transition-timing-function: ease;
}

.mapboxgl-ctrl-top-left {
  display: flex;
  display: flex;
  display: -moz-flex;
  display: -webkit-flex;
  display: -o-flex;
}

.mapboxgl-ctrl-top-left .mapboxgl-ctrl {
  display: flex;
  display: flex;
  display: -moz-flex;
  display: -webkit-flex;
  display: -o-flex;
}
.mapboxgl-ctrl-top-left .mapboxgl-ctrl-group button+button {
  border-left: 1px solid #ddd;
  border-top: none;
}

.my-custom-control {
  color: #f00;
  background: #000;
  padding: 8px;
  border-radius: 4px;
  margin: 8px;
}

</style>
